/* mu-reviews-box.js — MyUSACrafts Reviews Box
   Spalten-Aufklapp-Logik fuer "Show more reviews".
   Verhalten 1:1 wie im Referenz-Skript der Section reviews_box.
   Gehoert ausschliesslich zu sections/mu-reviews-box.liquid. */
(function () {
  if (window.strykReviewsBoxLoaded) return;
  window.strykReviewsBoxLoaded = true;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRbMore(box) {
    if (box.dataset.rbMoreInit) return;
    box.dataset.rbMoreInit = '1';
    var grid = box.querySelector('.stryk-rb__grid');
    var btn = box.querySelector('.stryk-rb__more');
    if (!grid || !btn) return;
    var batch = parseInt(btn.getAttribute('data-batch'), 10) || 6;
    var initial = parseInt(grid.getAttribute('data-initial'), 10) || 6;
    var initialMobile = parseInt(grid.getAttribute('data-initial-mobile'), 10) || initial;
    if (!(window.matchMedia && window.matchMedia('(min-width: 750px)').matches)) {
      initial = initialMobile;
    }
    // alle gerenderten Karten als Pool einsammeln, Grid leeren
    var pool = Array.prototype.slice.call(grid.querySelectorAll('.stryk-rb__card'));
    if (!pool.length) return;
    pool.forEach(function (c) {
      c.parentNode.removeChild(c);
    });
    // echte Spalten-Divs (Flexbox) -> neue Karten kommen unten an die kuerzeste Spalte = KEIN Rebalance/Springen
    grid.classList.add('stryk-rb__grid--cols');
    var ncols = window.matchMedia && window.matchMedia('(min-width: 990px)').matches ? 3 : 2;
    var cols = [];
    for (var i = 0; i < ncols; i++) {
      var col = document.createElement('div');
      col.className = 'stryk-rb__col';
      grid.appendChild(col);
      cols.push(col);
    }
    var added = 0;
    function shortestCol() {
      var s = cols[0];
      for (var j = 1; j < cols.length; j++) {
        if (cols[j].offsetHeight < s.offsetHeight) {
          s = cols[j];
        }
      }
      return s;
    }
    function appendOne(animate) {
      var src = pool[added % pool.length];
      var card = added < pool.length ? src : src.cloneNode(true); // erst echte, dann alte zyklisch geklont
      card.hidden = false;
      if (animate) {
        card.classList.add('stryk-rb__card--in');
      }
      shortestCol().appendChild(card);
      added++;
    }
    function addCards(count, animate) {
      if (!animate) {
        for (var j = 0; j < count; j++) {
          appendOne(false);
        }
        return;
      }
      // smooth: Grid-Hoehe von alt -> neu animieren (overflow:hidden enthuellt die neuen Karten beim Wachsen)
      var hBefore = grid.offsetHeight;
      for (var k = 0; k < count; k++) {
        appendOne(true);
      }
      var hAfter = grid.offsetHeight;
      grid.style.overflow = 'hidden';
      grid.style.height = hBefore + 'px';
      grid.getBoundingClientRect();
      grid.style.transition = 'height .5s ease';
      grid.style.height = hAfter + 'px';
      var clear = function () {
        grid.style.transition = '';
        grid.style.height = '';
        grid.style.overflow = '';
        grid.removeEventListener('transitionend', clear);
      };
      grid.addEventListener('transitionend', clear);
      setTimeout(clear, 650);
    }
    addCards(initial, false); // Start ohne Animation
    btn.addEventListener('click', function () {
      addCards(batch, !reduceMotion); // Nachladen sanft aufgehen lassen
    });
  }

  function initAll() {
    document.querySelectorAll('.stryk-rb').forEach(initRbMore);
  }

  if (document.readyState !== 'loading') initAll();
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
